<template>
  <div>
    <b-form-radio-group
      :options="options"
      v-model="post"
      :required="required"
      @input="send"
      value-field="dd_o_value"
      text-field="dd_o_label"
    ></b-form-radio-group>
  </div>
</template>
    
<script>
export default {
  props: ["name", "validation", "content", "dropdown_name"],
  data() {
    return {
      post: (typeof this.content !== 'undefined' && this.content !== null && this.content !== '') ? this.content : 0,
      options: [],
    };
  },
  mounted() {
    this.axios
      .get("/dropdown/list/" + this.dropdown_name)
      .then((response) => {
        this.options = response.data.data;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 500) {
            console.log("error 500");
          }
        }
      });
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
  },
  methods: {
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post,
      });
    },
  },
};
</script>